import { useMutation } from '@tanstack/react-query';
import { SupportBoardUserType, SupportRequests } from 'src/requests/support';
import { QueryKey, queryClient } from 'src/utils/react-query';

export const useSupportBoardMutation = () => {
  const { mutateAsync: getToken, isLoading: isGettingToken } = useMutation(
    SupportRequests.getSupportBoardId,
    {
      onSuccess: (data) => {
        queryClient.setQueryData<SupportBoardUserType>(
          [QueryKey.SUPPORT, data.helpCenterUserId],
          data,
        );
      },
    },
  );

  return {
    getToken,
    isGettingToken,
  };
};
